import { render } from "./EmailPreview.vue?vue&type=template&id=6bfd31bc&scoped=true"
import script from "./EmailPreview.vue?vue&type=script&lang=js"
export * from "./EmailPreview.vue?vue&type=script&lang=js"

import "./EmailPreview.vue?vue&type=style&index=0&id=6bfd31bc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfd31bc"]])

export default __exports__